<template>
    <div class="main">
        <HeaderNav :numbers="numbers" :testTabs="testTabs" />
        <div class="">
            <router-view></router-view>
        </div>
        <!-- <FooterBlock/> -->
    </div>
</template>
<script>
import HeaderNav from "../components/Header.vue";
// import FooterBlock from "../components/Footer.vue";
import uploadIcon from "../assets/img/icon/upload.svg";
import uploadIconActive from "../assets/img/icon/upload_yellow.svg";
import recordIcon from "../assets/img/icon/record.svg";
import recordIconActive from "../assets/img/icon/record_yellow.svg";
import verifyIcon from "../assets/img/icon/verify.svg";
import verifyIconActive from "../assets/img/icon/verify_yellow.svg";

export default {
    name: "HomePage",
    components: {
        HeaderNav,
        // FooterBlock,
    },
    data() {
        return {
            numbers: [1, 2, 3],
            testTabs: [{
                    img: uploadIcon,
                    activeImg: uploadIconActive,
                    title: "存證證據",
                    href: "/upload",
                    isActive: true,
                },
                {
                    img: recordIcon,
                    activeImg: recordIconActive,
                    title: "上鏈紀錄",
                    href: "/record",
                    isActive: false,
                },
                {
                    img: verifyIcon,
                    activeImg: verifyIconActive,
                    title: "驗證證據",
                    href: "/verify",
                    isActive: false,
                },
            ],
        }
    },
    methods: {
        getNavItem(nav) {
            console.log(nav);
        }
    }
};
</script>